/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MoveToDetailsIconContainer from '../../../NDC/component/MoveToDetailsIconContainer/MoveToDetailsIconContainer';
import SearchComponent from '../../../NDC/component/NDCByID/SearchComponent';
import { searchNDCByIDORDrugName } from '../../../NDC/store/action';
import {
  checkClaimAndAddToDetailsTable,
  removeFromClaimDetailsTableData,
  setClaimDetailsTableData,
  setClaimErrorPopupMessage,
  setClaimLoading,
  setEnteredNdc,
} from '../../store/action';
import ClaimsDetailsTable from './ClaimsDetailsTable';

const SearchByNDC = ({
  fullScreen,
  setFullScreen,
  setError: setClaimHeaderError,
}) => {
  const dispatch = useDispatch();
  // const [searchByNDCID, setSearchByNDCID] = useState("");
  const searchByNDCID = useSelector(
    (state) => state.sharedState.claim.enteredNdc
  );
  const [error, setError] = useState('');

  const handleSearchClick = async () => {
    const searchByNDCIDSplit = searchByNDCID.split('-');

    if (
      (searchByNDCIDSplit.length == 1 && searchByNDCIDSplit[0].length === 11) ||
      (searchByNDCIDSplit.length === 3 &&
        searchByNDCIDSplit[0].length === 5 &&
        searchByNDCIDSplit[1].length === 4 &&
        searchByNDCIDSplit[2].length === 2)
    ) {
      dispatch(setClaimLoading(true));
      const searchResult = await searchNDCByIDORDrugName({
        searchBy: 'ndc',
        inputValue: searchByNDCID,
      });
      dispatch(setClaimLoading(false));

      if (!searchResult) {
        const errorMessage = 'NDC not found';
        dispatch(setClaimErrorPopupMessage(errorMessage));
        setError(errorMessage);
      } else {
        dispatch(setClaimErrorPopupMessage(null));
        setError(null);
        dispatch(checkClaimAndAddToDetailsTable(searchResult));
      }
    } else if (!searchByNDCID || !searchByNDCID.trim()) {
      const errorMessage = 'Please input an NDC to search';
      dispatch(setClaimErrorPopupMessage(errorMessage));
      setError(errorMessage);
    } else {
      const errorMessage =
        'Please enter NDC in the format XXXXX-XXXX-XX or XXXXXXXXXXX';
      dispatch(setClaimErrorPopupMessage(errorMessage));
      setError(errorMessage);
    }
  };

  return (
    <>
      <div className="col-5 d-flex">
        <SearchComponent
          searchByNDCID={searchByNDCID}
          setSearchByNDCID={(e) => dispatch(setEnteredNdc(e))}
          className="ml-0"
          error={error}
          searchOnEnter={handleSearchClick}
        />
      </div>
      <div className="col-2 px-2">
        <MoveToDetailsIconContainer
          handleSingleMove={() => handleSearchClick()}
          handleAllRemove={() => {
            dispatch(setClaimDetailsTableData([]));
          }}
          handleSingleRemove={() => {
            dispatch(removeFromClaimDetailsTableData());
          }}
        />
      </div>
      <div className="col-5  d-flex flex-column p-0">
        <ClaimsDetailsTable
          fullScreen={fullScreen}
          setFullScreen={setFullScreen}
          setError={setClaimHeaderError}
        />
      </div>
    </>
  );
};

export default SearchByNDC;
